import {SiteArea} from '../constants/navigation';
import {Logger} from '~/src/utilities/helpers/log';
import {getJsonRequest} from '../helpers/request';
import {fetchAdditionalData, parseCategory} from './data';

type SiteAreas = typeof SiteArea[keyof typeof SiteArea];
type Options = {
    siteArea: SiteAreas;
    sitemap: any;
};

export const fetchCategoryData = async (url: string, {siteArea, sitemap}: Options) => {
    try {
        const response = await getJsonRequest(url);
        const data = parseCategory(response, siteArea, sitemap);
        await fetchAdditionalData(data);

        return data;
    } catch (error) {
        Logger.info(`[${error.name}][CategoryFeed] error while getting data`, {error});

        return {error};
    }
};
